<template>
  <div :class="style.content">
    <div :class="style.tabs">
      <TabPanel
        text="Настройки"
        :active="activeSection === 'Настройки'"
        @click="setActiveSection('Настройки')"
      />

      <TabPanel
        text="Контент"
        :active="activeSection === 'Контент'"
        @click="setActiveSection('Контент')"
      />
    </div>

    <div v-if="activeSection === 'Настройки'" :class="style.contentPart">
      <div :class="style.input">
        <SelectBase
          comment="Тип блока"
          :items="typeBlocks"
          :text="getFormTypeString"
          @select="changeFormStyle"
        />
      </div>

      <div :class="style.input" v-if="isFormType">
        <span :class="style.heading">Доступные поля</span>

        <div :class="style.checkboxes">
          <CheckboxComponent
            text="Имя"
            :modelValue="askName"
            @update:modelValue="changeAskName"
          />

          <CheckboxComponent
            text="Телефон"
            :modelValue="askPhone"
            @update:modelValue="changeAskPhone"
          />

          <CheckboxComponent
            text="Email"
            :modelValue="askEmail"
            @update:modelValue="changeAskEmail"
          />

          <CheckboxComponent
            text="Способы связи"
            :modelValue="askConnectionList"
            @update:modelValue="changeAskConnections"
          />
        </div>
      </div>

      <div :class="style.input" v-if="isFormType && askPhone">
        <div :class="style.switch">
          <span :class="style.heading">Маска телефона</span>

          <SwitchComponent
            :modelValue="phoneMask"
            @update:modelValue="changePhoneMask"
          />
        </div>
      </div>

      <div :class="style.input" v-if="isFormType && askPhone">
        <SelectBase
          comment="Код страны"
          :items="countryList"
          :text="countryText"
          @select="changeCountry"
        />
      </div>

      <div :class="style.input" v-if="isFormType && askConnectionList">
        <span :class="style.heading">Способ связи</span>

        <div :class="style.checkboxes">
          <CheckboxComponent
            text="Телефон"
            value="phone"
            :modelValue="connectionTypes"
            @update:modelValue="changeConnectionTypes"
          />

          <CheckboxComponent
            text="WhatsApp"
            value="Whats App"
            :modelValue="connectionTypes"
            @update:modelValue="changeConnectionTypes"
          />

          <CheckboxComponent
            text="Viber"
            value="viber"
            :modelValue="connectionTypes"
            @update:modelValue="changeConnectionTypes"
          />

          <CheckboxComponent
            text="Telegram"
            value="telegram"
            :modelValue="connectionTypes"
            @update:modelValue="changeConnectionTypes"
          />
        </div>
      </div>
    </div>

    <div v-if="activeSection === 'Контент'" :class="style.contentPart">
      <div :class="style.input">
        <InputStyle
          textarea
          description="Заголовок"
          placeholder="Введите заголовок"
          size="M"
          :modelValue="headerText"
          @input="changeHeaderText"
        />
      </div>

      <div :class="style.input">
        <InputStyle
          textarea
          description="Описание"
          placeholder="Введите описание"
          size="M"
          :modelValue="paragraphText"
          @input="changeDescriptionText"
        />
      </div>

      <div :class="style.input">
        <InputStyle
          description="Текст кнопки"
          placeholder="Введите текст"
          size="M"
          :modelValue="buttonText"
          @input="changeButtonText"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import style from "./HeaderSettingComponent.module.scss";
import {defineComponent} from "vue";
import {
  ConnectionType,
  ContactField,
  CountryName,
  Quiz
} from "@/page/quiz/typeQuiz";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";

import TabPanel from "@/elements/UI/tabs/TabPanel/TabPanel.vue";
import SelectBase from "@/elements/UI/select/SelectBase.vue";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";
import CheckboxComponent from "@/elements/UI/input/Checkbox/CheckboxComponent.vue";
import SwitchComponent from "@/elements/UI/input/Switch/SwitchComponent.vue";

type ContactConnectionItem = {
  type?: string;
  value?: CheckboxValue;
  name?: string;
  key?: string;
  text?: string;
  bool?: boolean;
};

type ContactFieldItem = {
  bool: boolean;
};

type ContactFieldsObject = {
  name: ContactFieldItem;
  email: ContactFieldItem;
  connectionList: ContactFieldItem;
  phone: ContactFieldItem;
  country: CountryName;
  [key: string]: unknown;
};

type RawContactFieldsObject = {
  name?: Partial<ContactFieldItem> | boolean;
  email?: Partial<ContactFieldItem> | boolean;
  connectionList?: Partial<ContactFieldItem> | boolean;
  phone?: Partial<ContactFieldItem> | boolean;
  country?: CountryName | string;
};

type ContactQuestion = {
  type?: string;
  contacts?: RawContactFieldsObject;
  connection?: ContactConnectionItem[];
  phoneMask?: boolean;
};

export default defineComponent({
  name: "HeaderSettingComponent",

  components: {
    SwitchComponent,
    CheckboxComponent,
    InputStyle,
    SelectBase,
    TabPanel
  },

  data() {
    return {
      style,
      modifyQuiz,
      activeSection: "Настройки" as SelectedPanel,

      typeBlocks: [
        {
          text: "Квиз",
          value: "quiz",
          variant: "tab"
        },
        {
          text: "Форма",
          value: "form",
          variant: "tab"
        }
      ] as SelectItem[],

      countryList: [
        {
          text: "Россия (+7)",
          value: "Россия (+7)",
          variant: "tab"
        },
        {
          text: "Казахстан (+7)",
          value: "Казахстан (+7)",
          variant: "tab"
        }
      ] as SelectItem[]
    };
  },

  methods: {
    setActiveSection(name: SelectedPanel): void {
      this.activeSection = name;
    },

    changeFormStyle(payload: SelectBasePayload): void {
      this.modifyQuiz("set", payload.value === "form", ["onlyFormBool"]);
    },

    changeHeaderText(event: Event): void {
      const target = event.target as HTMLInputElement;

      this.modifyQuiz("set", target.value, ["header"]);
    },

    changeDescriptionText(event: Event): void {
      const target = event.target as HTMLInputElement;

      this.modifyQuiz("set", target.value, ["paragraf"]);
    },

    changeButtonText(event: Event): void {
      const target = event.target as HTMLInputElement;

      this.modifyQuiz("set", target.value, ["nextButton"]);
    },

    changeConnectionTypes(value: ConnectionType[]): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      const nextConnection = this.createNextConnectionList(value);

      this.modifyQuiz("set", nextConnection, [
        "questions",
        this.contactsQuestionIndex,
        "connection"
      ]);
    },

    changeAskName(value: boolean): void {
      this.setContactField("name", value);
    },

    changeAskEmail(value: boolean): void {
      this.setContactField("email", value);
    },

    changeAskConnections(value: boolean): void {
      this.setContactField("connectionList", value);
    },

    changeAskPhone(value: boolean): void {
      this.setContactField("phone", value);
    },

    changePhoneMask(value: boolean): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      this.modifyQuiz("set", value, [
        "questions",
        this.contactsQuestionIndex,
        "phoneMask"
      ]);
    },

    changeCountry(payload: SelectBasePayload): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      const country = this.normalizeCountry(payload.value);

      const contacts = {
        ...this.contactsObject,
        country
      };

      this.modifyQuiz("set", contacts, [
        "questions",
        this.contactsQuestionIndex,
        "contacts"
      ]);
    },

    setContactField(field: ContactField, value: boolean): void {
      if (this.contactsQuestionIndex === -1) {
        return;
      }

      const contacts = {
        ...this.contactsObject,
        [field]: {
          ...(this.contactsObject[field] ?? {}),
          bool: value
        }
      };

      this.modifyQuiz("set", contacts, [
        "questions",
        this.contactsQuestionIndex,
        "contacts"
      ]);
    },

    createNextConnectionList(
      selectedConnectionTypes: ConnectionType[]
    ): ContactConnectionItem[] {
      const currentConnection = this.contactsQuestion?.connection;

      if (!Array.isArray(currentConnection)) {
        return [];
      }

      return currentConnection.map((connectionItem, connectionIndex) => {
        const fallbackConnectionType =
          this.allowedConnectionTypes[connectionIndex];
        const connectionType =
          this.getConnectionTypeFromItem(connectionItem) ||
          fallbackConnectionType;

        return {
          ...connectionItem,
          bool: selectedConnectionTypes.includes(connectionType)
        };
      });
    },

    getConnectionTypeFromItem(
      item: ContactConnectionItem
    ): ConnectionType | "" {
      const rawValue =
        item.type ?? item.value ?? item.name ?? item.key ?? item.text ?? "";

      return this.normalizeConnectionType(rawValue);
    },

    normalizeConnectionType(value: unknown): ConnectionType | "" {
      const normalizedValue = String(value)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/-/g, "")
        .replace(/_/g, "");

      if (normalizedValue === "phone" || normalizedValue === "телефон") {
        return "phone";
      }

      if (
        normalizedValue === "whatsapp" ||
        normalizedValue === "whatsup" ||
        normalizedValue === "ватсап" ||
        normalizedValue === "вацап"
      ) {
        return "Whats App";
      }

      if (normalizedValue === "viber" || normalizedValue === "вайбер") {
        return "viber";
      }

      if (
        normalizedValue === "telegram" ||
        normalizedValue === "телеграм" ||
        normalizedValue === "tg"
      ) {
        return "telegram";
      }

      return "";
    },

    normalizeContactField(
      value: unknown,
      defaultValue: boolean
    ): ContactFieldItem {
      if (value && typeof value === "object" && !Array.isArray(value)) {
        const field = value as ContactFieldItem;

        return {
          ...field,
          bool: typeof field.bool === "boolean" ? field.bool : defaultValue
        };
      }

      if (typeof value === "boolean") {
        return {
          bool: value
        };
      }

      return {
        bool: defaultValue
      };
    },

    normalizeCountry(value: unknown): CountryName {
      if (
        value === "Казахстан" ||
        value === "Казахстан (+7)" ||
        value === "kz" ||
        value === "KZ"
      ) {
        return "Казахстан (+7)";
      }

      return "Россия (+7)";
    }
  },

  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },

    questions(): ContactQuestion[] {
      const value = this.modifyQuiz("get", "", ["questions"]);

      return Array.isArray(value) ? value : [];
    },

    contactsQuestionIndex(): number {
      const contactsIndex = this.questions.findIndex((question) => {
        return question?.type === "contacts";
      });

      if (contactsIndex !== -1) {
        return contactsIndex;
      }

      if (this.questions.length >= 2) {
        return this.questions.length - 2;
      }

      return -1;
    },

    contactsQuestion(): ContactQuestion | null {
      if (this.contactsQuestionIndex === -1) {
        return null;
      }

      return this.questions[this.contactsQuestionIndex] ?? null;
    },

    contactsObject(): ContactFieldsObject {
      const contacts = this.contactsQuestion?.contacts;

      if (
        contacts &&
        typeof contacts === "object" &&
        !Array.isArray(contacts)
      ) {
        return {
          ...contacts,
          name: this.normalizeContactField(contacts.name, true),
          email: this.normalizeContactField(contacts.email, true),
          connectionList: this.normalizeContactField(
            contacts.connectionList,
            true
          ),
          phone: this.normalizeContactField(contacts.phone, true),
          country: this.normalizeCountry(contacts.country)
        };
      }

      return {
        name: {
          bool: true
        },
        email: {
          bool: true
        },
        connectionList: {
          bool: true
        },
        phone: {
          bool: true
        },
        country: "Россия (+7)"
      };
    },

    allowedConnectionTypes(): ConnectionType[] {
      return ["phone", "Whats App", "viber", "telegram"];
    },

    headerText(): string {
      const value = this.modifyQuiz("get", "", ["header"]);

      return typeof value === "string" ? value : "";
    },

    paragraphText(): string {
      const value = this.modifyQuiz("get", "", ["paragraf"]);

      return typeof value === "string" ? value : "";
    },

    buttonText(): string {
      const value = this.modifyQuiz("get", "", ["nextButton"]);

      return typeof value === "string" ? value : "";
    },

    connectionTypes(): ConnectionType[] {
      const connection = this.contactsQuestion?.connection;

      if (!Array.isArray(connection)) {
        return [];
      }

      return connection.reduce(
        (
          result: ConnectionType[],
          item: ContactConnectionItem,
          connectionIndex: number
        ) => {
          if (item.bool !== true) {
            return result;
          }

          const fallbackConnectionType =
            this.allowedConnectionTypes[connectionIndex];
          const connectionType =
            this.getConnectionTypeFromItem(item) || fallbackConnectionType;

          if (!connectionType) {
            return result;
          }

          result.push(connectionType);

          return result;
        },
        []
      );
    },

    askName(): boolean {
      return this.contactsObject.name.bool;
    },

    askEmail(): boolean {
      return this.contactsObject.email.bool;
    },

    askPhone(): boolean {
      return this.contactsObject.phone.bool;
    },

    askConnectionList(): boolean {
      return this.contactsObject.connectionList.bool;
    },

    phoneMask(): boolean {
      const value = this.contactsQuestion?.phoneMask;

      if (typeof value === "boolean") {
        return value;
      }

      return false;
    },

    country(): CountryName {
      return this.contactsObject.country;
    },

    countryText(): string {
      return this.country;
    },

    isFormType(): boolean {
      return this.getFormTypeString === "Форма";
    },

    getFormTypeString(): string {
      const onlyFormBool = this.modifyQuiz("get", "", ["onlyFormBool"]);

      return onlyFormBool ? "Форма" : "Квиз";
    }
  }
});
</script>
